export default __webpack_public_path__ + "static/media/T560MANL2.1a12db90.pdf";